import { useUserSession } from '../../models/hooks/appStateHooks';
import { useManagerPermissions } from '../hooks/useManagerPermissions';
import { useMyOverdueTimeEntriesQuery, useTimeEntryDayQuery, useTimeEntryReviewQueueQuery } from '../queries/TimeEntry';
import { todayYmd } from './days';

export function useTimeTracking() {
	const userSession = useUserSession();
	const enabled = userSession.account?.features?.aida?.timeTrackingEnabled === true;
	const { isAdmin, isManager, hasManagerPermissions, isLoading: isLoadingPermissions } = useManagerPermissions();

	const today = useTimeEntryDayQuery({ day: todayYmd(), enabled, toastOnError: false });
	const overdue = useMyOverdueTimeEntriesQuery({ enabled });
	const reviewQueue = useTimeEntryReviewQueueQuery({ enabled });

	const overdueCount = overdue.data?.totalCount ?? 0;
	const reviewCount = reviewQueue.data?.totalCount ?? 0;

	return {
		canActAsSelf: !userSession.isCustomerImpersonation,
		enabled,
		isAdmin,
		isManager,
		overdueCount,
		reviewCount,
		showHoursReview: enabled && (hasManagerPermissions || reviewCount > 0),
		showTimesheet:
			enabled &&
			!isLoadingPermissions &&
			(!hasManagerPermissions || today.data?.isRequired === true || overdueCount > 0),
	};
}
